module.exports = __webpack_public_path__ + "img/logo_sahel.c518e8de.png";